import { render, staticRenderFns } from "./codeEdit.vue?vue&type=template&id=12ae3914&scoped=true&"
import script from "./codeEdit.vue?vue&type=script&lang=js&"
export * from "./codeEdit.vue?vue&type=script&lang=js&"
import style0 from "./codeEdit.vue?vue&type=style&index=0&id=12ae3914&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae3914",
  null
  
)

export default component.exports